document.addEventListener('change', function (event) {
  if (event.target.matches('[data-product-select]')) {
    var option = event.target.options[event.target.selectedIndex];
    var button = document.querySelector('[data-add-to-cart]');
    if (button) {
      button.disabled = option.disabled;
      button.textContent = option.disabled ? 'Currently unavailable' : 'Add guide to cart';
    }
  }
});

